import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import SidebarAdministracion from "../components/header/sidebarAdministracion";
import FamiliaresHistoryTable from "../components/invitadosFrecuentes/familiaresTable";
import Paginador from "../components/paginador/paginador";
import Controls from '../components/controls/controls';
import Request from "../core/httpClient";
import DinamicModal from '../components/dinamicModal/dinamicModal';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Autocomplete from '../components/controls/autocomplete';
const request = new Request();


class vacacionalHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {}

    }

    render() {
        return (
            <div className="catalogos">
                <Helmet>
                    <title>iGate - Vacacional</title>
                </Helmet>
                <Header sidebar={true} nav={"catalogos"} />
                <div className="row justify-center">
                    <div className="column" id="sidebar">
                        <SidebarAdministracion/>
                    </div>
                    <div className="container column" id="content">
                        <div className="container column align-center">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio fuga voluptas, in minus veniam neque cum dolorum sunt excepturi.
                             Cum adipisci quis pariatur saepe quaerat repellat, quisquam totam nemo nihil.
                             Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi officiis non, nostrum nobis numquam quasi laboriosam vel facere
                             excepturi quia sunt tempora harum est ipsa repudiandae ab asperiores placeat maxime!
                        </div>


                    </div>

                </div>
            </div >);
    }

}

export default vacacionalHistory;